import { render, staticRenderFns } from "./KitPresse.vue?vue&type=template&id=6716ccf2&"
import script from "./KitPresse.vue?vue&type=script&lang=js&"
export * from "./KitPresse.vue?vue&type=script&lang=js&"
import style0 from "./KitPresse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports